export default "__VITE_ASSET__c8cd8a13__"